import { createSelector } from '@reduxjs/toolkit';
import type { IUserProfilePromo } from '../../types/userProfile';
import { userProfileClientInfoSelector } from './userProfileClientInfoSelector';

export const userProfilePromoSelector = createSelector(
  [userProfileClientInfoSelector],
  (clientInfo): IUserProfilePromo | null => {
    return clientInfo?.promo || null;
  },
);
